import React from "react";
import Popover from "../../../../../components/popover/Popover";

export default function WelcomeMessageHelp({ buttonClassName }: {buttonClassName?: string}) {
    return (
        <Popover buttonClassName={buttonClassName} title="Welcome Message Template" size="md">
            <div>
                <p>
                    When a ticket is created in Slack, Foqal Agent will automatically respond with the
                    message you specify. For example, you can use something like:
                </p>
                <blockquote className="alert alert-light">
                    <em>
                        Hey, 👋 welcome. Please remember to use a thread! We will be right with you.
                    </em>
                </blockquote>

                <p>
                    <h5>Variables</h5>
                    To make the message more helpful, you can use variables which will be replaced
                    with the associated values at the time the ticket is created. In the above example,
                    <code>&#123;&#123;FIRST_NAME&#125;&#125;</code>
                    {" "}
                    and
                    {" "}
                    <code>&#123;&#123;LAST_NAME&#125;&#125;</code>
                    are variables which will be replaced with the requesters first name and last name respectively.
                    You can use the following variables in your template
                </p>
                <ul>
                    <li>
                        <code>&#123;&#123;TICKET_NUMBER&#125;&#125;</code>
                        {" "}
                        - The number for the newly created ticket.
                    </li>
                    <li>
                        <code>&#123;&#123;FIRST_NAME&#125;&#125;</code>
                        {" "}
                        - The first name of the requester.
                    </li>
                    <li>
                        <code>&#123;&#123;LAST_NAME&#125;&#125;</code>
                        {" "}
                        - The last name of the requester
                    </li>
                    <li>
                        <code>&#123;&#123;NAME&#125;&#125;</code>
                        {" "}
                        - The full name of the requester.
                    </li>

                </ul>
            </div>
        </Popover>
    );
}

WelcomeMessageHelp.defaultProps = {
    buttonClassName: "",
};
